import { Box, BoxProps } from '@material-ui/core';
import React, { FC } from 'react';

export const AppBold: FC<BoxProps> = (props) => (
  <Box fontWeight="bold" display="inline" {...props} />
);
